import { createSignal, onCleanup, onMount } from 'solid-js'

export type Breakpoint = 'mobile' | 'tablet' | 'desktop'

function getBreakpoint(width: number): Breakpoint {
  if (width >= 960) return 'desktop'
  if (width >= 640) return 'tablet'
  return 'mobile'
}

export function useBreakpoint() {
  const [bp, setBp] = createSignal<Breakpoint>(
    typeof window !== 'undefined' ? getBreakpoint(window.innerWidth) : 'desktop'
  )

  onMount(() => {
    const onResize = () => setBp(getBreakpoint(window.innerWidth))
    window.addEventListener('resize', onResize)
    onCleanup(() => window.removeEventListener('resize', onResize))
  })

  return bp
}
